export default function dateString(format = 0, date = new Date()) {
    switch (format) {
        case 0:
            return new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
                .toISOString()
                .replace('Z', 'UTC-' + (date.getTimezoneOffset() / 60))
                .replace('--', '+');
        case 1:
            return date
                .toLocaleString()
                .replaceAll(',', '')
                .split('/')
                .map((v, i) =>
                    i !== 1 ? v :
                        ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Dic'][Number(v) - 1]
                )
                .join('/');
        case 2:
            return new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
                .toISOString()
                .substring(0, 10)
                .replace(/-/g, '');
        case 3:
            return date.getMonth() < 8 ? '0' : ''
                + (date.getMonth() + 2)
                + String(date.getFullYear()).substring(2, 4);
        case 4:
            return date.toLocaleDateString().split('/').map(n => ((Number(n) < 10 ? '0' : '') + Number(n))).join('/')
                + ' '
                + date.toLocaleTimeString().split(':').map(n => ((Number(n) < 10 ? '0' : '') + Number(n))).join(':');
        default:
            return ''
    }
}


